import React from 'react';
import {
  Grid, Typography, useTheme,
} from '@mui/material';
import useStyles from './styles';

type colors = 'primary' | 'alternativePrimary' | 'secondary' | 'alternativeSecondary'
type variants = 'h1' | 'h2' | 'h3' | 'h4' | 'h5'|'h6'|'body1'

interface ViewTitleProps{
    title?: string|React.ReactElement,
    subtitle?: string,
    color: colors,
    variant?: variants,
    xs?: number,
    md?: number,
    lg?: number,
    disablePadding?: boolean,
    customHeight?: string|number
}
const defaultProps = {
  title: '',
  subtitle: '',
  variant: 'h4',
  lg: 12,
  md: 12,
  xs: 12,
  disablePadding: false,
  customHeight: '10%',

};
export default function ViewTitle(props: ViewTitleProps) {
  const {
    title,
    subtitle,
    color,
    variant,
    lg,
    md,
    xs,
    disablePadding,
    customHeight,
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [selectedColor, setSelectedColor] = React.useState(theme.palette.secondary.main);
  React.useEffect(() => {
    if (color === 'primary') {
      setSelectedColor(theme.palette.primary.main);
    }
    if (color === 'alternativePrimary') {
      setSelectedColor(theme.palette.secondary.main);
    }
  }, []);

  return (
    <Grid
      className={classes.viewTitle}
      sx={{ marginInline: { xs: 2, md: 0 }, marginBlock: { xs: 2, md: 1 } }}
      style={{
        padding: disablePadding ? 0 : '0px 1%',
        height: customHeight,
      }}
      xs={xs}
      md={md}
      lg={lg}
      item
    >
      <div>
        {title !== '' && (
          <>
            <Typography
              variant={variant}
              component="div"
            >
              {title}
            </Typography>
            <div style={{
              borderBottom: `4px solid ${selectedColor}`,
              padding: '0 0 0px',
              width: '50px',
              margin: '5px 0',
            }}
            />
          </>
        )}

        <Typography
          variant="body2"
          component="div"
          align="left"
        >
          {subtitle}
        </Typography>
      </div>
    </Grid>
  );
}

ViewTitle.defaultProps = defaultProps;
